import { useState } from 'react';

//* Components
import Filters from '../Filters';
import Text from '@/components/common/Text';
import Icon from '@/components/common/Icon';
import SortBy from '@/components/pages/shop/SortBy';

const MobileFilter = ({ searchParams, filters, onFilterChange }) => {
	//! State
	const [isFilterDropDownActive, setIsFilterDropDownActive] = useState();

	return (
		<div className='filters-wrap'>
			<button
				className='filter-button'
				onClick={() => setIsFilterDropDownActive(!isFilterDropDownActive)}>
				<Icon
					className={'h2 white filter-icon'}
					name={isFilterDropDownActive ? 'close' : 'filter'}
				/>
				<Text
					className={'h2 font-futura-medium white'}
					text={isFilterDropDownActive ? 'close' : 'filter'}
				/>
			</button>
			<div className={`dropdown ${isFilterDropDownActive ? 'active' : ''}`}>
				<Filters
					isMobile
					filters={filters}
					searchParams={searchParams}
					onFilterChange={onFilterChange}
				/>
			</div>
			<SortBy onFilterChange={onFilterChange} />
		</div>
	);
};

export default MobileFilter;
